import('./bootstrap')
    // eslint-disable-next-line no-console
    .catch((err) => console.error(err));
